import React from 'react'
import { Button, Grid } from '@mui/material'
import { NavLink } from 'react-router-dom'
import Text from 'components/Text'
import ProductsNavigation from 'screens/ProductsSlider/components/ProductsNavigation/ProductsNavigation'
import HamburgerMenu from 'components/menu/HamburgerMenu'


export default function ProductsHeader({ productGuid }) {
  return <Grid sx={styles.menuRow} container>
    <Button
      variant='outlined'
      color='secondary'
      sx={styles.button}
      component={NavLink}
      to='/get-started'
    >
      <Text>Go Back</Text>
    </Button>
    <Grid sx={styles.bulletsWrapper} container>
      <ProductsNavigation {...{ productGuid }} />
    </Grid>
    <HamburgerMenu />
  </Grid>
}


const styles = {
  menuRow: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    width: '100%',
    padding: '1%',
  },
  bulletsWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    textTransform: 'none',
  },
}
